// extracted by mini-css-extract-plugin
module.exports = {"pieceTitle":"piece-module--pieceTitle--2f3vD","piece":"piece-module--piece--1WqMT"};